import styled, { css } from 'styled-components'

export const IconContainer = styled.div<{
  margin?: string
  iconsize?: number
  iconHeight?: number
}>`
  margin: ${props => props.margin ?? 'unset'};
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => {
    if (props.iconsize) {
      return css`
        svg {
          width: ${props.iconsize}px;
          height: ${props.iconHeight ?? props.iconsize}px;
        }
      `
    }
  }}
`
